'use client'

import { TCollectionData, TCollectionDetail } from '@/types/collection'
import { useMemo } from 'react'
import { useCollectionData } from '../hooks/use-collection-data'
import { SeoUpdater } from './seo-updater'

interface CollectionPageClientProps {
  collection: TCollectionDetail
  initialFilters?: Record<string, string | string[] | number | undefined>
}

/**
 * Client component to handle SEO updates based on latest collection data
 * This component subscribes to React Query and updates SEO when data changes
 */
export const CollectionPageClient = ({
  collection,
  initialFilters = {},
}: CollectionPageClientProps) => {
  // Subscribe to collection data updates (for filter changes, pagination, etc.)
  const { data: collectionData } = useCollectionData({
    serverData: { collection_detail: collection } as TCollectionData,
    initialFilters,
  })

  // Get latest collection_detail from React Query data
  const latestCollectionDetail = useMemo(
    () =>
      collectionData?.pages?.[collectionData.pages.length - 1]
        ?.collection_detail || collection,
    [collectionData?.pages, collection]
  )

  return <SeoUpdater collectionDetail={latestCollectionDetail} />
}
